import { render, staticRenderFns } from "./CoinbaseStakingSummary.vue?vue&type=template&id=34ef8a5f&scoped=true"
import script from "./CoinbaseStakingSummary.vue?vue&type=script&lang=js"
export * from "./CoinbaseStakingSummary.vue?vue&type=script&lang=js"
import style0 from "./CoinbaseStakingSummary.vue?vue&type=style&index=0&id=34ef8a5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ef8a5f",
  null
  
)

export default component.exports